<template>
  <div :class="{ 'alternative-item': alternativeLayout }">
    <div class="row row-question" @click="$emit('toggleFaq', itemId)">
      <img v-if="item.image" class="mb-2 pl-3 pr-5 pb-3 image-item" :src="item.image" />
      <h3
        class="question"
        :class="!item.image ? 'with-padding' : ''"
        :style="{
          color: item.isOpen && alternativeLayout ? '#5287f2' : textColor,
          textDecoration: textDecoration
        }"
      >
        {{ item.question }}
      </h3>
      <Icon
        v-if="alternativeLayout"
        class="icon-position"
        :icon="item.isOpen ? 'minus' : 'plus'"
        :color="item.isOpen ? '' : 'inherit'"
        :width="22"
        :height="22"
      />
    </div>
    <p v-if="isDefaultFaq" class="answer" :class="{ show: item.isOpen }">
      {{ item.answer }}
    </p>
    <prismic-rich-text
      v-else
      :field="item.answer"
      class="answer"
      :class="{ show: item.isOpen }"
      :style="answerStyle"
    ></prismic-rich-text>
  </div>
</template>

<script>
import Icon from 'UI/Icon';
export default {
  components: { Icon },
  props: {
    itemId: {
      type: Number,
      required: true
    },
    textColor: {
      type: String,
      required: false,
      default: ''
    },
    textDecoration: {
      type: String,
      required: false,
      default: ''
    },
    answerStyle: {
      type: Object,
      required: false,
      default: () => ({})
    },
    item: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isDefaultFaq: {
      type: Boolean,
      default: false,
      required: false
    },
    alternativeLayout: {
      type: Boolean,
      default: false,
      required: false
    }
  }
};
</script>
<style lang="scss" scoped>
.image-item {
  cursor: pointer;
  width: 100px;
  height: 60px;
}

.question {
  color: #787878;
  text-decoration: underline #787878;
  text-decoration-thickness: 2px;
  text-underline-offset: 7px;
  font-size: 20px;
  font-weight: 400;
  cursor: pointer;
  line-height: 40px;
  &.with-padding {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.answer {
  color: #787878;
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.3s, padding 0.3s;
}
.answer.show {
  padding: 15px 0;
  margin: 0;
  max-height: 1000px;
}
.alternative-item {
  padding: 0 35px;
  @include sm {
    padding: 0 25px 0 15px;
  }
  .row-question {
    cursor: pointer;
    position: relative;
    .icon-position {
      color: #d9d9d9;
      position: absolute;
      right: 0;
      top: 20px;
      @include sm {
        right: 10px;
      }
    }
    &:hover {
      .icon-position {
        color: $lightBlue;
      }
    }
  }
  .answer {
    font-size: 15px;
  }
  .answer.show {
    padding-top: 5px;
    margin: 0;
  }
  .question {
    text-decoration: none;
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    &.with-padding {
      padding: 10px 23px 10px 16px;
      @include sm {
        padding-right: 32px;
      }
    }
  }
}
</style>
